import { RouterProvider } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import routerRoutes from './config/routes';
import { useGetUserQuery } from './redux/auth/auth.api.slice';
import { setCredentials, setLogout } from './redux/auth/auth.slice';
import '@/assets/quill.css';
import '@/assets/postCommentsTimeline.css';

function App() {
  const dispatch = useDispatch();
  const { data: user, error, isLoading, isSuccess } = useGetUserQuery();

  useEffect(() => {
    if (isLoading) return; // Show a loading state if needed

    if (error) {
      dispatch(setLogout()); // Clear any previous credentials if there's an error
      return;
    }
    if (!user && !isLoading) {
      dispatch(setLogout());
      return;
    }
    if (isSuccess) {
      dispatch(setCredentials(user));
    }
  }, [user, error, isLoading, dispatch, isSuccess]);
  return <RouterProvider router={routerRoutes} />;
}

export default App;
